import { getIndustries } from 'app/api/RegistrationApi';
import Modal from "../../core/components/Modal/Modal";
import { Tab, Tabs } from "../../core/components/Tabs/TabVertical";
import { useEffect, useState } from 'react';
import { NavbarLogo } from 'tombac';
import { ChevronRightIcon } from 'tombac-icons';
import "./DashboardContactModal.css";
import ModalLicenseForm from "./ModalLicenseForm";
import ModalSupportForm from "./ModalSupportForm";
import SuccessPage from "./SuccessPage";
import { useProductsDataQuery, useUserDataQuery } from "./dashboardApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DashboardContactModal = _ref => {
  let {
    initialTab = 'sales',
    isOpen,
    onRequestClose,
    ...modalProps
  } = _ref;
  const [industries, setIndustries] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [initialTabIndex, setInitialTabIndex] = useState(0);
  const {
    data: products
  } = useProductsDataQuery(undefined, {
    enabled: isOpen
  });
  const {
    data: userData
  } = useUserDataQuery(undefined, {
    enabled: isOpen
  });
  useEffect(() => {
    if (!isOpen) return;
    setInitialTabIndex(initialTab === 'support' ? 1 : 0);
    getIndustries().then(setIndustries);
  }, [isOpen]);
  const onSubmitForm = () => {
    setIsSubmitted(true);
    onRequestClose();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Modal, {
      className: "DashboardContactModal DashboardContactModal--SuccessPage",
      isOpen: isSubmitted,
      onRequestClose: onRequestClose,
      size: "auto",
      ...modalProps,
      "data-sentry-element": "Modal",
      "data-sentry-source-file": "DashboardContactModal.tsx",
      "data-sentry-element": "Modal",
      children: /*#__PURE__*/_jsx(SuccessPage, {
        onConfirm: () => {
          setIsSubmitted(false);
          onRequestClose();
        },
        "data-sentry-element": "SuccessPage",
        "data-sentry-source-file": "DashboardContactModal.tsx",
        "data-sentry-element": "SuccessPage"
      })
    }), /*#__PURE__*/_jsx(Modal, {
      className: "DashboardContactModal",
      isOpen: isOpen,
      onRequestClose: onRequestClose,
      size: "auto",
      ...modalProps,
      "data-sentry-element": "Modal",
      "data-sentry-source-file": "DashboardContactModal.tsx",
      "data-sentry-element": "Modal",
      children: /*#__PURE__*/_jsxs("div", {
        className: "DashboardContactModal_body",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "DashboardContactModal_header",
          children: [/*#__PURE__*/_jsx(NavbarLogo, {
            className: "DashboardContactModal_logo",
            title: "Move",
            "data-sentry-element": "NavbarLogo",
            "data-sentry-source-file": "DashboardContactModal.tsx",
            "data-sentry-element": "NavbarLogo"
          }), /*#__PURE__*/_jsx("h2", {
            className: "DashboardContactModal_headerLabel",
            children: "Contact us"
          })]
        }), /*#__PURE__*/_jsxs(Tabs, {
          initialTabIndex: initialTabIndex,
          className: 'DashboardContactModal_Tabs',
          "data-sentry-element": "Tabs",
          "data-sentry-source-file": "DashboardContactModal.tsx",
          "data-sentry-element": "Tabs",
          children: [/*#__PURE__*/_jsx(Tab, {
            tabContent: /*#__PURE__*/_jsxs("div", {
              className: 'DashboardContactModal_TabContent',
              children: [/*#__PURE__*/_jsx("div", {
                className: 'DashboardContactModal_TabContent_label',
                children: "To upgrade or expand your license"
              }), /*#__PURE__*/_jsx(ChevronRightIcon, {
                className: "DashboardContactModal_TabContent_ico"
              }), /*#__PURE__*/_jsx("div", {
                className: 'DashboardContactModal_TabContent_desc',
                children: "To upgrade from an evaluation version, expand your license, or request collaboration with TomTom."
              })]
            }),
            "data-sentry-element": "Tab",
            "data-sentry-source-file": "DashboardContactModal.tsx",
            "data-sentry-element": "Tab",
            children: /*#__PURE__*/_jsx(ModalLicenseForm, {
              onRequestClose: onRequestClose,
              industries: industries,
              userData: userData,
              onSubmitForm: onSubmitForm,
              "data-sentry-element": "ModalLicenseForm",
              "data-sentry-source-file": "DashboardContactModal.tsx",
              "data-sentry-element": "ModalLicenseForm"
            })
          }), /*#__PURE__*/_jsx(Tab, {
            tabContent: /*#__PURE__*/_jsxs("div", {
              className: 'DashboardContactModal_TabContent',
              children: [/*#__PURE__*/_jsx("div", {
                className: 'DashboardContactModal_TabContent_label',
                children: "To request help from TomTom support"
              }), /*#__PURE__*/_jsx(ChevronRightIcon, {
                className: "DashboardContactModal_TabContent_ico"
              }), /*#__PURE__*/_jsx("div", {
                className: 'DashboardContactModal_TabContent_desc',
                children: "To report a bug, get help/guidance/workshops, or ask us product-related questions."
              })]
            }),
            "data-sentry-element": "Tab",
            "data-sentry-source-file": "DashboardContactModal.tsx",
            "data-sentry-element": "Tab",
            children: /*#__PURE__*/_jsx(ModalSupportForm, {
              onRequestClose: onRequestClose,
              products: products ?? [],
              onSubmitForm: onSubmitForm,
              userEmail: userData?.email,
              "data-sentry-element": "ModalSupportForm",
              "data-sentry-source-file": "DashboardContactModal.tsx",
              "data-sentry-element": "ModalSupportForm"
            })
          })]
        })]
      })
    })]
  });
};
export default DashboardContactModal;